// Mock data for Bond Collective clone
// NOTE: This is placeholder/mock data sourced from the live site for the frontend-only build.
import { BOOKING_BASE, BOOK_A_SPACE_URL } from "../config/links";

export const IMAGES = {
  loungeGreenpoint:
    "/locations-hero.jpg",
  privateOffice: "/memberships/private-office.jpg",
  dayPasses: "/memberships/day-pass.jpg",
  conferenceRoom: "/memberships/conference-room.jpg",
  dedicatedDesk: "/memberships/dedicated-desk.jpg",
  coworking: "/memberships/coworking.jpg",
  austinLounge:
    "https://www.bondcollective.com/wp-content/uploads/2024/02/Austin-lounge-coffee-table-chairs.jpg",
  amenitiesHero:
    "/amenities-hero.jpg",
  amenity1:
    "/amenity-1.jpg",
  amenity2:
    "/amenity-2.jpg",
  amenity3:
    "https://www.bondcollective.com/wp-content/uploads/2024/01/amenities-3-784x1024.jpg",
  amenity4:
    "https://www.bondcollective.com/wp-content/uploads/2024/01/amenities-4-784x1024.jpg",
  amenity5:
    "https://www.bondcollective.com/wp-content/uploads/2024/01/amenities-5-784x1024.jpg",
};

// Authentic per-location photos pulled directly from each bondcollective.com location page
const U = "https://www.bondcollective.com/wp-content/uploads";
export const LOCATION_PHOTOS = {
  "vinegar-hill": [
    `/locations/vinegar-hill-hero.jpg`,
    `${U}/2024/02/2_VinegarHill_Lounge_Hall.jpg`,
    `${U}/2024/02/3_BC_VinegarHill_Lounge_Straight_Logan_Temp.jpg`,
    `${U}/2024/02/5_VinegarHill_Kitchen_Coworking.jpg`,
    `${U}/2024/02/7_BC_VinegarHill_Office_wide_Logan_temp.jpg`,
    `${U}/2024/02/8_BC_VinegarHill_Conference_Round_Logan_temp.jpg`,
  ],
  "fidi-55": [
    `/locations/fidi-55-hero.jpg`,
    `${U}/2024/02/3_fidi-55broadway-kitchen.jpg`,
    `${U}/2024/02/4_fidi-55broadway-nassau-conference-rooms-office.jpg`,
    `${U}/2024/02/6_fidi-55broadway-office.jpg`,
    `${U}/2024/02/7_fidi-55broadway-lounge-kitchen-coworking.jpg`,
    `${U}/2024/02/10_fidi-55broadway-lounge-meeting-space.jpg`,
  ],
  bushwick: [
    `/locations/bushwick-hero.jpg`,
    `${U}/2024/02/6_bushwick-brick-temporary-office-space.jpg`,
    `${U}/2024/02/7_bushwick-office-space-private-office.jpg`,
    `${U}/2024/02/2_bushwick-meeting-booth-shared-office.jpg`,
    `${U}/2024/02/11_bushwick-conference-room-meeting-space.jpg`,
    `${U}/2024/02/1_bushwick-phone-booths-office-space.jpg`,
  ],
  greenpoint: [
    `/locations/greenpoint-hero-v2.jpg`,
    `${U}/2024/02/3-Greenpoint-New-York-Locations-Lounge.jpg`,
    `${U}/2024/02/10-Greenpoint-Diamond-Conference-Room.jpg`,
    `${U}/2024/02/14-Greenpoint-Conference-Rooms-Meeting-Cowork.jpg`,
    `${U}/2024/02/16-Greenpoint-Office-Conference-Team.jpg`,
    `${U}/2024/02/19-Greenpoint_OfficeSpace_Hallway.jpg`,
  ],
  "fidi-60": [
    `/locations/fidi-60-hero.jpg`,
    `${U}/2024/02/2-fidi-60broad-lounge-corporate-office.jpg`,
    `${U}/2024/05/fidi-60broad-kitchen-event-space.jpg`,
    `${U}/2024/05/fidi-60broad-office.jpg`,
    `${U}/2024/05/fidi-60broad-shared-office-space.jpg`,
    `${U}/2024/05/fidi-60broad-lounge-shared-space.jpg`,
  ],
  "center-city": [
    `/locations/center-city-hero.jpg`,
    `${U}/2024/02/1-philadelphia-reception.jpg`,
    `${U}/2024/02/3-philadelphia-kitchen.jpg`,
    `${U}/2024/02/4-philadelphia-conference.jpg`,
    `${U}/2024/02/8-philadelphia-reception-lounge.jpg`,
    `${U}/2024/02/12-Center-City-Terrace-Loungers.jpg`,
  ],
  "market-street": [
    `/locations/market-street-hero.jpg`,
    `/locations/market-street-g1.jpg`,
    `/locations/market-street-g2.jpg`,
    `/locations/market-street-g3.jpg`,
    `/locations/market-street-g4.jpg`,
    `/locations/market-street-g5.jpg`,
  ],
  "gather-4100": [
    `/locations/gather-4100-hero.jpg`,
    `/locations/gather-4100-g1.jpg`,
    `/locations/gather-4100-g2.jpg`,
    `/locations/gather-4100-g3.jpg`,
    `/locations/gather-4100-g4.jpg`,
    `/locations/gather-4100-g5.jpg`,
  ],
  "east-austin": [
    `/locations/east-austin-hero.jpg`,
    `${U}/2024/02/5-Austin-lounge-leather-sofa.jpg`,
    `${U}/2024/02/4-Austin-Wide-Lounge-Coworking-booths-kitchen.jpg`,
    `${U}/2024/02/3-Austin-conference-room-table.jpg`,
    `${U}/2024/02/9-Austin-Coworking-Table-Lamps.jpg`,
    `${U}/2024/02/11-Austin-Booth-Hallway-Office.jpg`,
  ],
};


export const MEMBERSHIPS = [
  {
    slug: "private-offices",
    name: "Private Office Space",
    price: "From $500",
    unit: "Per Month",
    image: IMAGES.privateOffice,
    tagline: "Your own private, lockable office.",
    description:
      "Fully furnished, move-in ready private offices designed for teams of 1 to 100+. Enjoy a dedicated, lockable space with all the amenities and perks of coworking, plus the privacy your business needs.",
    features: [
      "Furnished, lockable private office",
      "24/7 secure building access",
      "Mail & package handling",
      "Access to all common areas & lounges",
      "Custom build-outs available",
    ],
  },
  {
    slug: "dedicated-desk",
    name: "Dedicated Desks",
    price: "From $500",
    unit: "Per Month",
    image: IMAGES.dedicatedDesk,
    tagline: "A desk to call your own.",
    description:
      "Claim a permanent, reserved desk in our shared workspaces. Keep your setup exactly the way you like it while enjoying a vibrant, professional community around you.",
    features: [
      "Reserved desk, always yours",
      "24/7 access to your home location",
      "Ergonomic seating & storage",
      "High-speed WiFi & ethernet",
      "Complimentary coffee & spa water",
    ],
  },
  {
    slug: "coworking",
    name: "Coworking",
    price: "From $300",
    unit: "Per Month",
    image: IMAGES.coworking,
    tagline: "Flexible, open workspace.",
    description:
      "Work from any open seat across our beautifully designed lounges and common areas. Perfect for freelancers, remote workers, and small teams who want flexibility without compromise.",
    features: [
      "Hot-desk in any common area",
      "Business-hours access",
      "Networking events & community",
      "Unlimited B&W printing",
      "Discounted conference room hours",
    ],
  },
  {
    slug: "day-pass",
    name: "Day Passes",
    price: "From $25",
    unit: "Per Day",
    image: IMAGES.dayPasses,
    tagline: "A workspace for the day.",
    description:
      "Need a productive space for the day? Drop in and enjoy full access to our amenities, fast WiFi, and inspiring interiors, with no commitment required.",
    features: [
      "Full-day workspace access",
      "Fast, reliable WiFi",
      "Complimentary coffee & snacks",
      "Access to common lounges",
      "Pay as you go",
    ],
  },
  {
    slug: "conference-rooms",
    name: "Conference Rooms",
    price: "From $50",
    unit: "Per Hour",
    image: IMAGES.conferenceRoom,
    tagline: "Meet, pitch, and present.",
    description:
      "Book stylish, fully-equipped conference rooms for 2 to 20+ people. Impress clients and run productive meetings with screens, whiteboards, and guest reception included.",
    features: [
      "Rooms for 2 to 20+ people",
      "Screens, A/V & whiteboards",
      "Guest reception & greeting",
      "Hourly or full-day booking",
      "Catering available on request",
    ],
  },
];

export const LOCATIONS = [
  {
    id: "vinegar-hill",
    placeId: "ChIJXVe2Rf5bwokR7GMXtyGscu8",
    name: "Vinegar Hill",
    address: "295 Front Street",
    region: "New York",
    city: "Brooklyn, NY",
    image: LOCATION_PHOTOS["vinegar-hill"][0],
    blurb: "A waterfront-adjacent workspace in historic Vinegar Hill.",
    acceptingMembers: false,
  },
  {
    id: "fidi-55",
    placeId: "ChIJy6wbMhFawokRIvR-cB6LOrk",
    name: "FiDi — 55 Broadway",
    address: "55 Broadway",
    region: "New York",
    city: "Manhattan, NY",
    image: LOCATION_PHOTOS["fidi-55"][0],
    blurb: "Elevated coworking in the heart of the Financial District.",
  },
  {
    id: "bushwick",
    placeId: "ChIJOzqDAnRbwokRYFMc2VkvfP4",
    name: "Bushwick",
    address: "12 Park Street",
    region: "New York",
    city: "Brooklyn, NY",
    image: LOCATION_PHOTOS["bushwick"][0],
    blurb: "A creative, design-forward space in vibrant Bushwick.",
  },
  {
    id: "greenpoint",
    placeId: "ChIJ50siSdpZwokRd6mlzNKK89Y",
    name: "Greenpoint",
    address: "276 Greenpoint Ave",
    region: "New York",
    city: "Brooklyn, NY",
    image: "/locations/greenpoint-hero-v2.jpg",
    blurb: "Light-filled lounges and private offices in trendy Greenpoint.",
  },
  {
    id: "fidi-60",
    placeId: "ChIJCzk4rxZawokR8KSfXD8PXBY",
    name: "FiDi — 60 Broad Street",
    address: "60 Broad Street",
    region: "New York",
    city: "Manhattan, NY",
    image: LOCATION_PHOTOS["fidi-60"][0],
    blurb: "Premium private offices steps from the New York Stock Exchange.",
  },
  {
    id: "center-city",
    placeId: "ChIJPV72-cbHxokRAyQCM8cn8Io",
    name: "Center City (One Penn Center)",
    address: "1617 JFK Boulevard",
    region: "Pennsylvania",
    city: "Philadelphia, PA",
    image: LOCATION_PHOTOS["center-city"][0],
    blurb: "A landmark Center City address with refined, modern interiors.",
  },
  {
    id: "market-street",
    placeId: "ChIJN21JztzHxokRrtx86sAuZi8",
    name: "Market Street",
    address: "1635 Market Street",
    region: "Pennsylvania",
    city: "Philadelphia, PA",
    image: LOCATION_PHOTOS["market-street"][0],
    blurb: "Sophisticated workspace on Philadelphia's iconic Market Street.",
  },
  {
    id: "gather-4100",
    placeId: "ChIJ309I5aCr2YgRgOIGtmE_TFU",
    name: "Gather 4100",
    address: "4100 Hollywood Boulevard",
    region: "Florida",
    city: "Hollywood, FL",
    image: LOCATION_PHOTOS["gather-4100"][0],
    blurb: "Focused, private executive suites in a convenient Florida location.",
  },
  {
    id: "east-austin",
    placeId: "ChIJ28CxNyq1RIYRrn6en8qHBAs",
    name: "East Austin",
    address: "310 Comal Street",
    region: "Texas",
    city: "Austin, TX",
    image: LOCATION_PHOTOS["east-austin"][0],
    blurb: "Bright, eclectic workspace in the heart of East Austin.",
  },
];

export const REGIONS = ["New York", "Pennsylvania", "Florida", "Texas"];

export const AMENITIES = [
  "Conference Rooms for 2 or 20+",
  "Custom Build-Outs",
  "Private Meeting & Phone Booths",
  "Guest Reception & Greeting",
  "Expertly Designed Interiors",
  "Mail and Package Handling",
  "Fast, Reliable WiFi and Ethernet",
  "Unlimited Black & White Printing",
  "Daily Porter & Nightly Cleanings",
  "Handymen & Installations Available",
  "Amenitized Showers with Towel Service",
  "Fresh Fruit, Snacks & Weekly Breakfast",
  "Complimentary Spa Water, Craft Beer & Coffee",
  "Mothers' Room",
  "Secure Bike Storage",
  "Curated Networking Events",
  "Exclusive Discounts & National Partnerships",
  "Pet-friendly Locations & Common Areas",
  "Access to Other Portfolio Locations",
  "Streamlined Billing & Booking Portal",
];

export const TESTIMONIALS = [
  {
    quote:
      "An amazing experience, to be honest. We have our own space and identity with all the amenities and perks of coworking.",
    name: "Yuni Sameshima",
    title: "Founder & CEO, Chicory",
  },
  {
    quote:
      "The design, the light, the people — everything about Bond Collective makes our team excited to come to work every day.",
    name: "Marcus Lee",
    title: "Co-Founder, Northbound Studio",
  },
  {
    quote:
      "Flexible terms, beautiful spaces, and a team that genuinely cares. It's the easiest decision we made this year.",
    name: "Priya Nair",
    title: "Operations Lead, Vela Health",
  },
];

// Form dropdown options (exact from source site)
export const WORKSPACE_OPTIONS = [
  "Undecided",
  "Downtown LA",
  "The Loop",
  "Fulton Market",
  "FiDi 55 Broadway",
  "Gowanus",
  "FiDi 60 Broad",
  "Greenpoint",
  "Bushwick",
  "Vinegar Hill",
  "Center City",
  "Market Street",
  "Gather 4100",
  "East Austin",
];

export const INTEREST_OPTIONS = [
  "Coworking Membership",
  "Dedicated Desk",
  "1-Person Office",
  "2-Person Office",
  "3-Person Office",
  "4-Person Office",
  "5-Person Office",
  "6-Person Office",
  "7-Person Office",
  "8-Person Office",
  "9-Person Office",
  "10-15 Person Office",
  "15-20 Person Office",
  "20+ Person Office",
  "Day Passes",
  "Conference Rooms",
  "Event Rentals",
];

export const NAV = {
  locationGroups: (() => {
    const order = [];
    const map = {};
    LOCATIONS.forEach((l) => {
      const city = l.city.split(",")[0].trim();
      if (!map[city]) {
        map[city] = [];
        order.push(city);
      }
      map[city].push({ name: l.name, id: l.id, acceptingMembers: l.acceptingMembers !== false });
    });
    return order.map((city) => ({
      city,
      items: map[city]
        .slice()
        .sort((a, b) => (a.acceptingMembers === b.acceptingMembers ? 0 : a.acceptingMembers ? -1 : 1)),
    }));
  })(),
  memberships: [
    { name: "Day Passes", slug: "day-pass" },
    { name: "Conference Rooms", slug: "conference-rooms" },
    { name: "Coworking", slug: "coworking" },
    { name: "Dedicated Desks", slug: "dedicated-desk" },
    { name: "Private Office Space", slug: "private-offices" },
  ],
};

export const COMPANY = {
  email: "hello@bondcollective.com",
  phone: "(929) 588-8294",
  portal: BOOK_A_SPACE_URL, // "Book a Space" — edit in /src/config/links.js
  member: "#", // member login link to be provided later
};

// ---- Per-location detail content (mocked) ----
const STD_HOURS = [
  { d: "Monday – Thursday", h: "8:30 AM – 5:30 PM" },
  { d: "Friday", h: "8:30 AM – 3:00 PM" },
  { d: "Members", h: "24 / 7 Access" },
];

// Center City keeps shorter staffed hours, Mon–Thu only
const CC_HOURS = [
  { d: "Monday – Thursday", h: "9:00 AM – 5:00 PM" },
  { d: "Members", h: "24 / 7 Access" },
];

// Bushwick staffed hours
const BU_HOURS = [
  { d: "Monday – Thursday", h: "9:00 AM – 5:00 PM" },
  { d: "Friday", h: "9:00 AM – 3:00 PM" },
  { d: "Members", h: "24 / 7 Access" },
];

const STD_AMENITIES = [
  "24/7 Secure Access",
  "Conference Rooms",
  "Private Phone Booths",
  "Fast WiFi & Ethernet",
  "Complimentary Coffee & Spa Water",
  "Mail & Package Handling",
  "Guest Reception",
  "Pet-Friendly Common Areas",
];

// Philadelphia locations are not pet-friendly
const STD_AMENITIES_NO_PETS = STD_AMENITIES.filter((a) => a !== "Pet-Friendly Common Areas");

// Greenpoint offers extra wellness/community amenities
const GP_AMENITIES = [
  ...STD_AMENITIES,
  "Secure Bike Storage",
  "Library Space",
  "Wellness Rooms for New Parents",
];

const g = (...keys) => keys.map((k) => IMAGES[k]);

export const LOCATION_DETAILS = {
  "vinegar-hill": {
    intro:
      "Tucked along Brooklyn's cobblestone waterfront, our Vinegar Hill space pairs industrial character with refined, light-filled interiors. It's a calm, design-forward base just minutes from DUMBO and the Brooklyn Bridge.",
    neighborhood:
      "Vinegar Hill is one of Brooklyn's best-kept secrets: historic streets, the East River esplanade, and a tight-knit community of makers and creatives.",
    transit: "F to York St · A/C to High St",
    parking: "Street parking & nearby garages",
    hours: STD_HOURS,
    amenities: STD_AMENITIES,
    gallery: [
      "/locations/vinegar-hill-g2.jpg",
      "/locations/vinegar-hill-g1.jpg",
      "/locations/vinegar-hill-g3.jpg",
    ],
  },
  "fidi-55": {
    intro:
      "In the beating heart of the Financial District, 55 Broadway delivers polished private offices and inviting lounges steps from Wall Street and Bowling Green.",
    neighborhood:
      "FiDi blends landmark architecture with a fast-growing residential scene, with world-class dining, transit, and the waterfront all within reach.",
    transit: "4/5 to Bowling Green · R/W to Rector St",
    parking: "Multiple nearby parking garages",
    hours: STD_HOURS,
    amenities: STD_AMENITIES,
    gallery: [
      "/locations/fidi-55-g1.jpg",
      "/locations/fidi-55-g2.jpg",
      "/locations/fidi-55-g3.jpg",
      "/locations/fidi-55-g4.jpg",
      "/locations/fidi-55-g5.jpg",
    ],
  },
  bushwick: {
    intro:
      "Bushwick's creative energy meets considered design. Expect bold interiors, plenty of natural light, and a community that's as ambitious as it is welcoming.",
    neighborhood:
      "A hub for artists, founders, and independent studios. Bushwick is rich with galleries, coffee, and some of Brooklyn's best food.",
    transit: "J/M to Flushing Avenue",
    parking: "GMC Parking (24/7 garage), 0.2 mi away. Street parking available — avoid the truck loading zone.",
    hours: BU_HOURS,
    amenities: STD_AMENITIES,
    gallery: [
      "/locations/bushwick-g1.jpg",
      "/locations/bushwick-g2.jpg",
      "/locations/bushwick-g3.jpg",
      "/locations/bushwick-g4.jpg",
    ],
  },
  greenpoint: {
    intro:
      "Greenpoint's leafy, design-forward workspace offers light-filled lounges and private offices with skyline views, perfect for teams that want room to grow.",
    neighborhood:
      "Greenpoint pairs waterfront parks with a thriving food and nightlife scene, all a quick ferry or train ride from Manhattan.",
    transit: "G to Greenpoint Ave · NYC Ferry",
    parking: "Street parking & nearby lots",
    hours: STD_HOURS,
    amenities: GP_AMENITIES,
    gallery: [
      "/locations/greenpoint-g1.jpg",
      "/locations/greenpoint-g2.jpg",
      "/locations/greenpoint-g3.jpg",
      "/locations/greenpoint-g4.jpg",
      "/locations/greenpoint-g5.jpg",
    ],
  },
  "fidi-60": {
    intro:
      "Premium private offices moments from the New York Stock Exchange. 60 Broad Street is built for established teams who want privacy without sacrificing amenities.",
    neighborhood:
      "Steps from Stone Street's cobblestoned dining row and a short walk to the Seaport, this is downtown Manhattan at its most dynamic.",
    transit: "2/3 to Wall St · J/Z to Broad St",
    parking: "Several garages within two blocks",
    hours: STD_HOURS,
    amenities: STD_AMENITIES,
    gallery: [
      "/locations/fidi-60-g1.jpg",
      "/locations/fidi-60-g2.jpg",
      "/locations/fidi-60-g3.jpg",
      "/locations/fidi-60-g4.jpg",
      "/locations/fidi-60-g5.jpg",
    ],
  },
  "center-city": {
    intro:
      "A landmark Center City address inside the historic One Penn Center. Refined, modern interiors meet unbeatable convenience for Philadelphia professionals.",
    neighborhood:
      "Center City is Philadelphia's commercial core, surrounded by transit, hotels, restaurants, and the city's cultural institutions.",
    transit: "Suburban Station | City Hall Station",
    parking: "Nearby Garages",
    hours: CC_HOURS,
    amenities: STD_AMENITIES_NO_PETS,
    gallery: [
      "/locations/center-city-g1.jpg",
      "/locations/center-city-g2.jpg",
      "/locations/center-city-g3.jpg",
      "/locations/center-city-g4.jpg",
    ],
  },
  "market-street": {
    intro:
      "Sophisticated workspace on Philadelphia's iconic Market Street, designed for focus and built for collaboration.",
    neighborhood:
      "Right on the city's main commercial spine, with effortless access to transit, dining, and the heart of downtown Philadelphia.",
    transit: "15th St Station · Market-Frankford Line",
    parking: "Garage parking nearby",
    hours: STD_HOURS,
    amenities: STD_AMENITIES_NO_PETS,
    gallery: LOCATION_PHOTOS["market-street"],
  },
  "gather-4100": {
    intro:
      "Focused, private executive suites in a convenient Florida setting. Gather 4100 offers the quiet, professional environment growing teams need. Your workspace, your way.",
    neighborhood:
      "Located on Hollywood Boulevard with easy highway access and a relaxed South Florida pace, plus beaches a short drive away.",
    transit: "US-1 · Free on-site parking",
    parking: "Free on-site parking",
    hours: STD_HOURS,
    amenities: STD_AMENITIES,
    gallery: LOCATION_PHOTOS["gather-4100"],
  },
  "east-austin": {
    intro:
      "Bright, eclectic workspace in the heart of East Austin. Expect warm interiors, an energetic community, and a true reflection of the city's creative spirit.",
    neighborhood:
      "East Austin is the city's most vibrant district, with independent coffee, live music, food trucks, and a fast-growing tech community.",
    transit: "Plaza Saltillo Station · Ample bike parking",
    parking: "On-site & street parking",
    hours: STD_HOURS,
    amenities: STD_AMENITIES,
    gallery: [
      "/locations/east-austin-g1.jpg",
      "/locations/east-austin-g2.jpg",
      "/locations/east-austin-g3.jpg",
      "/locations/east-austin-g4.jpg",
      "/locations/east-austin-g5.jpg",
    ],
  },
};

// ---- About page content (mocked) ----
export const ABOUT = {
  heroImage: "/about-hero.jpg",
  tagline: "Our Story",
  heading: "Workspaces designed for the way you actually work.",
  intro:
    "Bond Collective began with a simple belief: the place you work should inspire you. We set out to build workspaces that feel less like an office and more like a beautifully designed home for ambitious people and the teams they're building.",
  paragraphs: [
    "From our first location to a portfolio spanning the East Coast to Texas and Florida, every Bond Collective space is thoughtfully curated, from the furniture and lighting to the art on the walls and the coffee in your cup.",
    "We pair striking, design-led interiors with genuine hospitality and the flexibility modern teams need. Whether you're a solo founder, a remote worker, or a growing company, there's a home for you here.",
  ],
  stats: [
    { value: "5", label: "Cities" },
    { value: "4", label: "States" },
    { value: "24/7", label: "Member Access" },
    { value: "100%", label: "Move-In Ready" },
  ],
  values: [
    {
      icon: "Sparkles",
      title: "Design-Led",
      desc: "Every detail is considered. We believe beautiful spaces make for better work.",
    },
    {
      icon: "HeartHandshake",
      title: "Hospitality-First",
      desc: "Our teams treat members like guests, with service that's personal and proactive.",
    },
    {
      icon: "Users",
      title: "Community",
      desc: "Curated events and shared spaces designed to spark real connection.",
    },
    {
      icon: "Infinity",
      title: "Flexibility",
      desc: "Month-to-month terms and spaces that scale as your needs change.",
    },
  ],
  quote:
    "We're not just renting space — we're creating environments where people genuinely love to spend their days.",
};

// ---- Team (mocked) - pulled from bondcollective.com/about-us. Leadership first, then alphabetical. ----
export const TEAM = {
  leadership: [
    { name: "Gregg Jackowitz", title: "Chief Executive Officer", img: "/team/gregg-jackowitz.webp" },
    { name: "Sally Forman", title: "Chief Operating Officer", img: "/team/sally-forman.jpg" },
    { name: "Jeffrey Jackowitz", title: "Director of Hospitality", img: "/team/jeffrey-jackowitz.jpg" },
    { name: "Nicholas Sposato", title: "Director, Construction & Facilities", img: "/team/nicholas-sposato.jpg" },
  ],
  members: [
    { name: "Ava Collins", title: "Executive Assistant", img: "/team/ava-collins.jpg" },
    { name: "Christian Juliano Rios", title: "Community Manager", img: "/team/christian-rios.webp" },
    { name: "Cristina Perez", title: "Porter", img: "/team/cristina-perez.jpg" },
    { name: "Edward Lin", title: "Digital Marketing Manager", img: "/team/edward-lin.jpg" },
    { name: "Emma Milano", title: "Community Manager", img: "/team/emma-milano.jpg" },
    { name: "Jade Petersen", title: "Staff Accountant", img: "/team/jade-petersen.jpg" },
    { name: "Jermaine Green", title: "Member Experience Associate", img: "/team/jermaine-green.jpg" },
    { name: "Marcus Seide", title: "Member Experience Associate", img: "/team/marcus-seide.jpg" },
    { name: "Miriam Arroyo", title: "Member Experience Associate", img: "/team/miriam-arroyo.jpg" },
    { name: "Nick DeNofa", title: "Operations & Regional Manager", img: "/team/nick-denofa.jpg" },
    { name: "Reggie Harris", title: "Handyman", img: "/team/reggie-harris.jpg" },
    { name: "Ronald Calderon", title: "Regional Manager, New York", img: "/team/ronald-calderon.jpg" },
    { name: "Russell Blaymore", title: "General Counsel", img: "/team/russell-blaymore.jpg" },
    { name: "Sadie Hewitt", title: "Member Experience Associate", img: "/team/sadie-hewitt.jpg" },
    { name: "Scott Sampson", title: "General Manager", img: "/team/scott-sampson.jpg" },
    { name: "Tina Castro", title: "Porter Manager", img: "/team/tina-castro.jpg" },
    { name: "Troy Welch", title: "Member Experience Associate", img: "/team/troy-welch.jpg" },
    { name: "Jade Guerriera", title: "Team Member", img: "/team/jade-guerriera.webp" },
    { name: "Israel Catalan", title: "Team Member", img: "/team/israel-catalan.webp" },
    { name: "Eulalia Rivera", title: "Team Member", img: "/team/eulalia-rivera.webp" },
  ],
};


// ---- Per-location membership options + meeting rooms with REAL booking links ----
// Source: each location page on bondcollective.com (booking links go to the live portal)
const PORTAL_APP = BOOKING_BASE;

const MEM_DESC = {
  teamSuites:
    "Ideal for teams of 25 or more who want a turn-key dedicated team suite with built-in meeting space, phone booths, and internal private offices.",
  privateOffice:
    "For one-person enterprises to teams of 50+, find the perfect space to call your own and maximize your productivity in our furnished private offices.",
  dedicatedDesks:
    "Take a step away from conventional coworking and work from your own desk in an inspiring communal environment.",
  coworking:
    "24/7 access to our open floor plan coworking. Network with those around you, and build your business from the ground up.",
  conference:
    "Entertaining a client or in town for a special project? Book a conference room by the hour or for a full day, with options seating 5-20+.",
  dayPasses:
    "Redeemable at any Bond Collective location during operating hours, day passes make dropping in easy.",
};

const INC_FULL = [
  "24/7 access to the space",
  "Conference room hours included",
  "Secure, fast, private WiFi",
  "Fully-furnished",
  "Complimentary coffee, tea, spa water, and kombucha",
  "Fruit, snacks, and weekly breakfast",
];
const INC_COWORK = [
  "24/7 access to the space",
  "Secure, fast, private WiFi",
  "Complimentary coffee, tea, spa water, and kombucha",
  "Fruit, snacks, and weekly breakfast",
];
const INC_CONF = [
  "TV with wireless laptop connectivity",
  "Secure, fast WiFi",
  "Complimentary coffee, tea, spa water, and kombucha",
  "Complimentary fruit and other snacks",
];
const INC_DAY = [
  "Secure, fast WiFi",
  "Complimentary coffee, tea, spa water, and kombucha",
  "Complimentary fruit and other snacks",
];

// Greenpoint-specific perks (beer + happy hour / community programming)
const GP_INC_FULL = [
  "24/7 access to the space",
  "Conference room hours included",
  "Secure, fast, private WiFi",
  "Fully-furnished",
  "Complimentary coffee, tea, beer, spa water, and kombucha",
  "Daily fresh fruit and snacks during operational hours, and weekly breakfast",
];
const GP_INC_COWORK = [
  "24/7 access to the space",
  "Secure, fast, private WiFi",
  "Complimentary coffee, tea, beer, spa water, and kombucha",
  "Daily fresh fruit and snacks during operational hours, and weekly breakfast",
  "Monthly happy hour events and community programming",
];
const GP_INC_SUITE = [...GP_INC_FULL, "Monthly happy hour events and community programming"];

// Bushwick-specific: no kombucha; clearer office furnishing description
const BU_INC_FULL = [
  "24/7 access to the space",
  "Conference room hours included",
  "Secure, fast, private WiFi",
  "Desk, chair, and keyed file cabinet provided",
  "Complimentary coffee, tea, and spa water",
  "Fruit, snacks, and weekly breakfast",
];
const BU_INC_COWORK = [
  "24/7 access to the space",
  "Secure, fast, private WiFi",
  "Complimentary coffee, tea, and spa water",
  "Fruit, snacks, and weekly breakfast",
];
const BU_INC_CONF = [
  "TV with wireless laptop connectivity",
  "Secure, fast WiFi",
  "Complimentary coffee, tea, and spa water",
  "Complimentary fruit and other snacks",
];
const BU_INC_DAY = [
  "Secure, fast WiFi",
  "Complimentary coffee, tea, and spa water",
  "Complimentary fruit and other snacks",
];

// Builds the standard 6-option membership list for a NY-style location.
const stdMemberships = (proid, { coworkAmenity, coworkGroup, dayGroup, links = true } = {}) => [
  {
    name: "Day Passes", price: "From $35", unit: "/day", desc: MEM_DESC.dayPasses, included: INC_DAY,
    bookLink: links && dayGroup ? `${PORTAL_APP}/acquireamembership?companyid=30&proid=${proid}&groupid=${dayGroup}` : null,
  },
  {
    name: "Conference Rooms", price: "From $55", unit: "/hour", desc: MEM_DESC.conference, included: INC_CONF,
    bookLink: links ? `${PORTAL_APP}/services/workspacelist?companyid=30&proid=${proid}&spacetypegroup=2` : null,
  },
  {
    name: "Coworking", price: "From $300", unit: "/month", desc: MEM_DESC.coworking, included: INC_COWORK,
    bookLink: links && coworkAmenity ? `${PORTAL_APP}/packagedetails?companyid=30&proid=${proid}&amenityid=${coworkAmenity}&groupid=${coworkGroup}` : null,
  },
  { name: "Dedicated Desks", price: "From $500", unit: "/month", desc: MEM_DESC.dedicatedDesks, included: INC_FULL, bookLink: null },
  { name: "Private Office Space", price: "From $800", unit: "/month", desc: MEM_DESC.privateOffice, included: INC_FULL, bookLink: null },
  { name: "Team Suites", price: "From $3,000", unit: "/month", desc: MEM_DESC.teamSuites, included: INC_FULL, bookLink: null },
];

const room = (proid, name, price, cap, spaceid, customUrl) => ({
  name,
  price: `$${price}/hour`,
  capacity: `Up to ${cap} people`,
  bookLink: customUrl || `${PORTAL_APP}/space?companyid=30&proid=${proid}&spaceid=${spaceid}`,
});

// Conference / meeting room photos (keyed by location id -> room name), pulled from bondcollective.com
export const ROOM_IMAGES = {
  "vinegar-hill": {
    Hudson: "/rooms/vinegar-hill-Hudson.jpg",
    Perry: "/rooms/vinegar-hill-Perry.jpg",
    York: `${U}/2024/05/York.png`,
  },
  "fidi-55": {
    "Nassau Boardroom": "/rooms/fidi-55-Nassau.jpeg",
    Morris: "/rooms/fidi-55-Morris.jpeg",
    Broadway: "/rooms/fidi-55-Broadway.jpg",
    Trinity: "/rooms/fidi-55-Trinity.jpg",
    Mulberry: `${U}/2024/05/small_mulberry.jpeg`,
    "Pine Lounge": "/rooms/fidi-55-Pine.jpeg",
    Exchange: "/rooms/fidi-55-Exchange.jpg",
  },
  bushwick: {
    Fayette: "/rooms/bushwick-Fayette.jpg",
    Ellery: "/rooms/bushwick-Ellery.jpg",
    Humboldt: "/rooms/bushwick-Humboldt.jpg",
    Myrtle: "/rooms/bushwick-Myrtle.jpg",
    Lewis: "/rooms/bushwick-Lewis.jpg",
  },
  greenpoint: {
    Henry: "/rooms/greenpoint-Henry.jpg",
    Leonard: "/rooms/greenpoint-Leonard.jpg",
    Humboldt: "/rooms/greenpoint-Humboldt.jpg",
    Diamond: "/rooms/greenpoint-Diamond.jpg",
    Jewel: "/rooms/greenpoint-Jewel.jpg",
  },
  "fidi-60": {
    Freedom: "/rooms/fidi-60-Freedom-Liberty.jpg",
    Liberty: "/rooms/fidi-60-Freedom-Liberty.jpg",
    Stone: "/rooms/fidi-60-Gold-Stone.jpg",
    State: "/rooms/fidi-60-State-Pearl.jpg",
    Pearl: "/rooms/fidi-60-State-Pearl.jpg",
    Gold: "/rooms/fidi-60-Gold-Stone.jpg",
  },
  "center-city": {
    Walnut: "/rooms/center-city-Market.jpg",
    Chestnut: "/rooms/center-city-Chestnut.jpg",
    Pine: "/rooms/center-city-Clover.jpg",
  },
  "market-street": {
    Arch: "/rooms/market-street-ArchVine.jpg",
    Vine: "/rooms/market-street-ArchVine.jpg",
    Cherry: "/rooms/market-street-Cherry.jpg",
    "Spring Garden": "/rooms/market-street-SpringGarden.jpg",
    Broad: "/rooms/market-street-Broad.jpg",
  },
  "east-austin": {
    Clarksville: "/rooms/east-austin-Clarksville.jpg",
    Comal: "/rooms/east-austin-Comal.jpg",
    Rosedale: "/rooms/east-austin-Rosedale.jpg",
    "Zilker": "/rooms/east-austin-CesarChavez.jpg",
    Bouldin: "/rooms/east-austin-Bouldin.jpg",
    "Hyde Park": "/rooms/east-austin-HydePark.jpg",
    "Sound Booth 1": "/rooms/east-austin-SoundBooth.jpg",
  },
};


export const LOCATION_OFFERINGS = {
  "vinegar-hill": {
    proid: 13,
    memberships: stdMemberships(13, { coworkAmenity: 678, coworkGroup: 41, dayGroup: 49 }),
    rooms: [
      room(13, "Hudson", 75, 8, 1494),
      room(13, "Perry", 50, 5, 1463),
      room(13, "York", 125, 10, 1506),
    ],
  },
  "fidi-55": {
    proid: 5,
    memberships: stdMemberships(5, { coworkAmenity: 779, coworkGroup: 14, dayGroup: 50 }),
    rooms: [
      room(5, "Nassau Boardroom", 120, 18, 558),
      room(5, "Morris", 60, 10, 557),
      room(5, "Broadway", 60, 8, 546),
      room(5, "Trinity", 40, 6, 629),
      room(5, "Mulberry", 40, 6, 565),
      room(5, "Pine Lounge", 40, 4, 617),
      room(5, "Exchange", 40, 4, 547),
    ],
  },
  bushwick: {
    proid: 8,
    memberships: [
      {
        name: "Day Passes", price: "From $40", unit: "/day",
        desc: "Drop in and get to work. Day passes give you full access to this Bushwick location during operating hours.",
        included: BU_INC_DAY,
        bookLink: `${PORTAL_APP}/acquireamembership?companyid=30&proid=8&groupid=52`,
      },
      {
        name: "Conference Rooms", price: "From $55", unit: "/hour", desc: MEM_DESC.conference, included: BU_INC_CONF,
        bookLink: `${PORTAL_APP}/services/workspacelist?companyid=30&proid=8&spacetypegroup=2`,
      },
      {
        name: "Coworking", price: "From $300", unit: "/month", desc: MEM_DESC.coworking, included: BU_INC_COWORK,
        bookLink: `${PORTAL_APP}/packagedetails?companyid=30&proid=8&amenityid=788&groupid=20`,
      },
      { name: "Dedicated Desks", price: "From $500", unit: "/month", desc: MEM_DESC.dedicatedDesks, included: BU_INC_FULL, bookLink: null },
      { name: "Private Office Space", price: "From $750", unit: "/month", desc: MEM_DESC.privateOffice, included: BU_INC_FULL, bookLink: null },
    ],
    rooms: [
      room(8, "Fayette", 80, 12, null, "https://partners.flexspace.ai/offerings/bond-collective-meeting-rooms/spaces/aba1935a-a84b-4131-bd59-592b8eb3fa71"),
      room(8, "Ellery", 80, 12, null, "https://partners.flexspace.ai/offerings/bond-collective-meeting-rooms/spaces/98665dda-ca78-4ab5-ba68-f8dc89de8fc1"),
      room(8, "Humboldt", 60, 8, 961),
      room(8, "Myrtle", 40, 6, 963),
      room(8, "Lewis", 40, 6, 962),
    ],
  },
  greenpoint: {
    proid: 10,
    memberships: [
      {
        name: "Day Passes", price: "From $45", unit: "/day", desc: MEM_DESC.dayPasses, included: INC_DAY,
        bookLink: `${PORTAL_APP}/acquireamembership?companyid=30&proid=10&groupid=56`,
      },
      {
        name: "Conference Rooms", price: "From $55", unit: "/hour", desc: MEM_DESC.conference, included: INC_CONF,
        bookLink: `${PORTAL_APP}/services/workspacelist?companyid=30&proid=10&spacetypegroup=2`,
      },
      {
        name: "Coworking", price: "From $300", unit: "/month", desc: MEM_DESC.coworking, included: GP_INC_COWORK,
        bookLink: `${PORTAL_APP}/packagedetails?companyid=30&proid=10&amenityid=797&groupid=24`,
      },
      { name: "Dedicated Desks", price: "From $500", unit: "/month", desc: MEM_DESC.dedicatedDesks, included: GP_INC_FULL, bookLink: null },
      {
        name: "Private Office Space", price: "From $585", unit: "/month",
        desc: "Fully furnished, move-in ready private offices for individuals and teams of up to 8 people.",
        included: GP_INC_FULL, bookLink: null,
      },
      {
        name: "Team Suites", price: "From $4,500", unit: "/month",
        desc: "Ideal for 9 to 15 person offices — a turn-key dedicated team suite with built-in meeting space and internal private offices.",
        included: GP_INC_SUITE, bookLink: null,
      },
    ],
    rooms: [
      room(10, "Henry", 80, 18, 1337),
      room(10, "Leonard", 80, 10, 1338),
      room(10, "Humboldt", 60, 8, 1339),
      room(10, "Diamond", 40, 6, 1336),
      room(10, "Jewel", 40, 4, 1335),
    ],
  },
  "fidi-60": {
    proid: 11,
    // 60 Broad is private-office focused — no day passes or coworking offered here
    memberships: stdMemberships(11, { links: false }).filter(
      (m) => !["Day Passes", "Coworking"].includes(m.name)
    ),
    rooms: [
      room(11, "Freedom", 80, 10, 1121),
      room(11, "Liberty", 80, 10, 1123),
      room(11, "Stone", 40, 6, 1126),
      room(11, "State", 40, 6, 1125),
      room(11, "Pearl", 40, 6, 1124),
      room(11, "Gold", 40, 6, 1122),
    ],
  },
  "center-city": {
    proid: 12,
    memberships: [
      {
        name: "Day Passes", price: "From $45", unit: "/day",
        desc: "Drop in and get to work. Day passes give you full access to this Center City location during operating hours.",
        included: INC_DAY,
        bookLink: `${PORTAL_APP}/acquireamembership?companyid=30&proid=12&groupid=53`,
      },
      {
        name: "Conference Rooms", price: "From $50", unit: "/hour",
        desc: "Entertaining a client or in town for a special project? Book a conference room by the hour or for a full day, with options seating 6-16.",
        included: INC_CONF,
        bookLink: `${PORTAL_APP}/services/workspacelist?companyid=30&proid=12&spacetypegroup=2`,
      },
      {
        name: "Coworking", price: "From $300", unit: "/month", desc: MEM_DESC.coworking, included: INC_COWORK,
        bookLink: `${PORTAL_APP}/packagedetails?companyid=30&proid=12&amenityid=809&groupid=28`,
      },
      { name: "Dedicated Desks", price: "From $500", unit: "/month", desc: MEM_DESC.dedicatedDesks, included: INC_FULL, bookLink: null },
      { name: "Private Office Space", price: "From $1,000", unit: "/month", desc: MEM_DESC.privateOffice, included: INC_FULL, bookLink: null },
      {
        name: "Team Suites", price: "From $6,600", unit: "/month",
        desc: "A turn-key dedicated team suite with built-in meeting space and internal private offices.",
        included: INC_FULL, bookLink: null,
      },
    ],
    rooms: [
      room(12, "Walnut", 100, 16, 1225),
      room(12, "Chestnut", 75, 8, 1226),
      room(12, "Pine", 55, 6, 1224),
    ],
  },
  "market-street": {
    proid: 14,
    memberships: [
      { name: "Day Passes", price: "From $35", unit: "/day", desc: MEM_DESC.dayPasses, included: INC_DAY, bookLink: `${PORTAL_APP}/acquireamembership?companyid=30&proid=14&groupid=57` },
      { name: "Conference Rooms", price: "From $55", unit: "/hour", desc: MEM_DESC.conference, included: INC_CONF, bookLink: `${PORTAL_APP}/services/workspacelist?companyid=30&proid=14&spacetypegroup=2` },
      { name: "Coworking", price: "From $300", unit: "/month", desc: MEM_DESC.coworking, included: INC_COWORK, bookLink: `${PORTAL_APP}/packagedetails?companyid=30&proid=14&amenityid=810&groupid=44` },
      { name: "Dedicated Desks", price: "From $500", unit: "/month", desc: MEM_DESC.dedicatedDesks, included: INC_FULL, bookLink: null },
      { name: "Private Office Space", price: "From $700", unit: "/month", desc: MEM_DESC.privateOffice, included: INC_FULL, bookLink: null },
    ],
    rooms: [
      room(14, "Arch", 45, 4, 1676),
      room(14, "Vine", 45, 4, 1680),
      room(14, "Cherry", 70, 7, 1677),
      room(14, "Spring Garden", 95, 10, 1681),
      room(14, "Broad", 150, 20, 1678),
    ],
  },
  "east-austin": {
    proid: 1,
    memberships: stdMemberships(1, { coworkAmenity: 808, coworkGroup: 6, dayGroup: 54 }),
    rooms: [
      room(1, "Clarksville", 120, 20, 97),
      room(1, "Comal", 80, 12, 93),
      room(1, "Rosedale", 60, 8, 98),
      room(1, "Zilker", 60, 8, 94),
      room(1, "Bouldin", 60, 8, 96),
      room(1, "Hyde Park", 40, 4, 95),
      room(1, "Sound Booth 1", 100, 3, 104),
    ],
  },
  "gather-4100": {
    proid: null,
    memberships: [
      {
        name: "Private Offices",
        price: "From $1,000",
        unit: "/month",
        desc: "Ideal for individuals looking for a private executive suite, or small teams.",
        included: ["24/7 access to the space", "Secure, fast, private WiFi", "Conference room hours included", "Fully-furnished"],
        bookLink: null,
      },
    ],
    rooms: [],
  },
};
